import script from "./TradingChecklist.vue?vue&type=script&setup=true&lang=js"
export * from "./TradingChecklist.vue?vue&type=script&setup=true&lang=js"

import "./TradingChecklist.vue?vue&type=style&index=0&id=37b34336&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37b34336"]])

export default __exports__